import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';

export const initHomePageSlider = () => {
    new Swiper('.hero-slider .swiper-container', {
        modules: [Navigation, Pagination, Autoplay],
        autoplay: {
            delay: 15000,
        },
        speed: 400,
        disableOnInteraction: true,
        loop: true,
        effect: 'fade',
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        paginationClickable: true,
        grabCursor: true,
        // navigation: {
        //     nextEl: '.hero-slider__nav-button--next',
        //     prevEl: '.hero-slider__nav-button--prev',
        // },
    });
};

export const initEmployeeSlider = () => {

    const swiper = new Swiper('.swiper', {
        modules: [Navigation],
        // Optional parameters
        //direction: 'vertical',
        loop: true,

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

    });
};

export const initBrandsCarousel = () => {
    new Swiper('.js-brand-swiper', {
        modules: [Navigation, Pagination, Autoplay],
        autoplay: {
            delay: 5000,
        },
        speed: 400,
        spaceBetween: 50,
        slidesPerView: 3,
        loop: true,
        effect: 'slide',
        grabCursor: true,
        // navigation: {
        //     nextEl: '#brand-swiper-button-next',
        //     prevEl: '#brand-swiper-button-prev',
        // },
        breakpoints: {
            639: {
                slidesPerView: 4
            },
            1023: {
                slidesPerView: 6
            }
        }
    });
};

export const initShortcutCarousel = () => {
    new Swiper('.js-shortcut-swiper', {
        modules: [Navigation, Pagination],
        spaceBetween: 10,
        slidesPerView: 1.3,
    });
};

export const initHeroSlider = () => {


};

export const initGalleryElementCarousel1 = () => {
	document.querySelectorAll('.js-gallery-element-carousel1').forEach(function (carousel) {
		new Swiper(carousel, {
			speed: 400,
			slidesPerView: 1,
			nextButton: carousel.parentNode.querySelector('.js-gallery-element-carousel1-next'),
			prevButton: carousel.parentNode.querySelector('.js-gallery-element-carousel1-prev'),
		});
	});
};

export const initGalleryElementCarousel2 = () => {
	document.querySelectorAll('.js-gallery-element-carousel2').forEach(function (carousel) {
		new Swiper(carousel, {
			speed: 400,
			spaceBetween: 8,
			slidesPerView: 2,
			nextButton: carousel.parentNode.querySelector('.js-gallery-element-carousel2-next'),
			prevButton: carousel.parentNode.querySelector('.js-gallery-element-carousel2-prev'),
			breakpoints: {
				639: {
					slidesPerView: 3
				},
				1023: {
					slidesPerView: 4
				}
			}
		});
	});
};


export const initProductListCarousel = () => {
    new Swiper('.js-product-list-swiper', {
        modules: [Navigation, Pagination, Autoplay],
        autoplay: {
            delay: 5000,
        },
        speed: 400,
        spaceBetween: 40,
        slidesPerView: 2,
        loop: true,
        effect: 'slide',
        grabCursor: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            639: {
                slidesPerView: 3
            },
            1023: {
                slidesPerView: 4
            }
        }
    });
};